import React, { useEffect, useState, useRef } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { UploadPopupProps, UploadFile } from "./upload-popup-props";
import FileUploader from "./file-upload-dropzoze";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
const UploadPopup: React.FC<UploadPopupProps> = ({
    title,
    open,
    onCancel,
    onOkay,
    buttonText,
    files = [],
    setFiles,
}) => {

    const [errorMsg, setErrorMsg] = useState<Record<string, string>>({})

    const disable = files.length === 0 || Object.keys(errorMsg)?.length > 0

    const handleAttach = () => {
        onOkay()
    }
     const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // true if screen ≤ 600px


    return (
        <Dialog
            open={open}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="update-popup-wrapper"
            slotProps={{
                paper: {
                    sx: {
                    width: isMobile ? "90%" : "570px", // 90% width on mobile
                    maxWidth: "95vw",                  // prevent overflow
                    minHeight: isMobile ? "auto" : "280px",
                    borderBottomLeftRadius: '30px',
                    borderBottomRightRadius: '30px',
                    top: 0,  // add spacing from top on mobile
                    margin: 0,
                    position: "absolute",
                    },
                },
            }}
        >
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <FileUploader
                    files={files}
                    setFiles={setFiles}
                    errorMsg={errorMsg}
                    setErrorMsg={setErrorMsg}
                />
            </DialogContent>
            <DialogActions className="button-wrapper">
                <Button onClick={onCancel} className="cancel-btn">
                    Cancel
                </Button>
                <Button
                    disabled={disable}
                    onClick={handleAttach}
                    autoFocus
                    className="update-btn"
                >
                    {buttonText || 'Attach'}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default UploadPopup;